import { ValidatedTextInput } from './input-text-validated'
class BirthdayInput extends ValidatedTextInput {
  constructor () {
    super()

    this.input = this
    this.validateInput = this.validateBirthday.bind(this)

    this.textInputElement = this.querySelector('[data-birthday-input]')
    this.notificationElement = this.querySelector('[data-input-validation-notification]')
    this.notificationText = this.notificationElement.querySelector('[data-notification-text]')

    this.birthdayFormat = this.dataset.format || 'MM/DD'

    this.localeStrings = {
      invalid_m_d: this.dataset.localeInvalid_m_d,
      invalid_m: this.dataset.localeInvalid_m,
      invalid_d: this.dataset.localeInvalid_d,
      invalid_length: this.dataset.localeInvalid_length,
    }

    this.textInputElement.addEventListener('keydown', (e) => this.maskInput(e))
    this.textInputElement.addEventListener('keyup', (e) => this.maskInput(e))
  }

  maskInput (e) {
    const key = e.key
    const value = this.textInputElement.value
    const isNumber = /^[0-9]$/i.test(key)

    if (key !== 'Backspace') {
      if (!isNumber || value.length >= 5) {
        e.preventDefault()
      } else if (value.length === 2) {
        e.preventDefault()
        this.textInputElement.value = value + '/'
      }
    } else {
      // Is backspace
      if (value[value.length - 1] === '/') {
        e.preventDefault()
        this.textInputElement.value = value.slice(0, 1)
      }
    }
  }

  validateBirthday (e) {
    const inputElementValue = e.target.value
    const monthIndex = this.birthdayFormat === 'MM/DD' ? 0 : 1
    const dayIndex = this.birthdayFormat === 'MM/DD' ? 1 : 0

    if (inputElementValue.length === 5) {
      const month = parseInt(inputElementValue.split('/')[monthIndex])
      const day = parseInt(inputElementValue.split('/')[dayIndex])
      const valid = this.isDateValid(month, day)

      if (!valid.month && !valid.day) {
        this.showNotification(this.localeStrings.invalid_m_d)
      } else if (!valid.month) {
        this.showNotification(this.localeStrings.invalid_m)
      } else if (!valid.day) {
        this.showNotification(this.localeStrings.invalid_d)
      } else {
        this.hideNotification()
      }
    } else if (inputElementValue.length > 0 && inputElementValue.length < 5) {
      this.showNotification(this.localeStrings.invalid_length)
    } else {
      this.hideNotification()
    }
    this.textInputElement.reportValidity()
  }

  isDateValid (m, d) {
    return {
      month: m > 0 && m <= 12,
      day: d > 0 && d <= this.daysInMonth(m)
    }
  }

  daysInMonth (m) {
    // m is indexed: 1-12
    switch (m) {
    case 2 : return 29
    case 4 : case 9 : case 6 : case 11 : return 30
    default : return 31
    }
  }
}

if (!customElements.get('birthday-input')) {
  customElements.define('birthday-input', BirthdayInput)
}
